import React, { useEffect, useState } from 'react';
import './ProgressBar.css';

const ProgressBar = ({value}) => {
    const [firstLoad, setFirstLoad] = useState(true);
    useEffect(() => {
      setFirstLoad(false);
    }, [value]);
    return (
        <div className="result-skill-bar">
          {
            firstLoad ?
            (<div className="result-skill-per"></div>):
            (<div className="result-skill-per" style={{width: `${value}%`}}></div>)
          }
        </div>
    )

}

export default ProgressBar;
